<section class="panel">
    <div class="filters">
        <label
            >Associação
            <select [(ngModel)]="tenantId" (change)="load()">
                <option value="">Todas</option>
                <option value="-">Sem associação</option>
                @for (t of tenants; track t) {
                <option [value]="t">{{ t }}</option>
                }
            </select>
        </label>
        <label
            >Entidade
            <input type="text" [(ngModel)]="entity" (keyup.enter)="load()" placeholder="ex.: animal" />
        </label>
        <label
            >Status
            <select [(ngModel)]="status" (change)="load()">
                <option value="">Todos</option>
                @for (s of statuses; track s) {
                <option [value]="s">{{ statusLabel(s) }}</option>
                }
            </select>
        </label>
        <label
            >Período
            <select [(ngModel)]="days" (change)="load()">
                <option value="1">Últimas 24 h</option>
                <option value="7">Últimos 7 dias</option>
                <option value="30">Últimos 30 dias</option>
                <option value="">Tudo</option>
            </select>
        </label>
        <button mat-stroked-button (click)="load()" [disabled]="state === 'loading'">Atualizar</button>
    </div>

    @if (state === 'loading') {
    <div class="center"><mat-spinner diameter="32"></mat-spinner></div>
    } @else if (state === 'error') {
    <div class="center">
        <p>Não foi possível carregar a caixa de entrada.</p>
        <button mat-stroked-button (click)="load()">Tentar novamente</button>
    </div>
    } @else if (!items.length) {
    <div class="center">Nenhum evento recebido com esses filtros.</div>
    } @else {
    <ul class="list">
        @for (i of items; track i._id) {
        <li>
            <button type="button" class="row" (click)="toggle(i)" [attr.aria-expanded]="openId === i._id">
                <span class="badge" [attr.data-status]="i.status">{{ statusLabel(i.status) }}</span>
                <b>{{ i.entity }}</b>
                <span class="muted">{{ i.method }}{{ i.pathId ? ' · ' + i.pathId : '' }}</span>
                <span class="muted">{{ i.tenantId || 'sem associação' }}</span>
                <span class="muted">{{ i.receivedAt | date: 'dd/MM HH:mm:ss' }}</span>
                <span class="muted">{{ i.attempts }} tent.</span>
            </button>
            @if (openId === i._id) {
            <div class="detail">
                @if (i.detail) {
                <p><b>Resultado:</b> {{ i.detail }}</p>
                } @if (detailState === 'loading') {
                <mat-spinner diameter="20"></mat-spinner>
                } @else if (detailState === 'error') {
                <p>Falha ao carregar o payload.</p>
                } @else {
                <pre>{{ prettyBody(detail?.body) }}</pre>
                <p class="muted">
                    {{ detail?.truncated ? 'Payload truncado no armazenamento. ' : '' }}Campos sensíveis (token, CPF,
                    e-mail, telefone) mascarados.
                </p>
                } @if (canReprocess(i)) {
                <button mat-stroked-button (click)="reprocess(i)" [disabled]="busy.has(i._id)">Reprocessar</button>
                }
            </div>
            }
        </li>
        }
    </ul>
    }
</section>
